export const formatPriorPeriodLabel = (start, end) => {
  if (!start || !end) return "Prior";
  const sameDay = start.year() === end.year() && start.month() === end.month() && start.date() === end.date();
  if (sameDay) return start.format("D MMM YYYY");
  return `${start.format("D MMM YYYY")}–${end.format("D MMM YYYY")}`;
};

export const formatPriorPeriodVsLabel = (timeframeId, timeframeName, priorStart, priorEnd) => {
  const id = (timeframeId || "").toLowerCase();
  if (id === "today") return "vs. Yesterday";
  if (id === "wtd")   return "vs. Previous Week";
  if (id === "mtd")   return "vs. Last Month";
  if (id === "qtd")   return "vs. Last Quarter";
  if (id === "ytd")   return "vs. Last Year";
  const name = (timeframeName || "").trim();
  const afterThis = name.startsWith("This ") ? name.slice(5) : null;
  const afterLast = name.startsWith("Last ") ? name.slice(5) : null;
  if (afterThis && !afterThis.includes(" ")) return `vs. Last ${afterThis}`;
  if (afterLast && (!afterLast.includes(" ") || /^\d+ \w+$/.test(afterLast))) return `vs. Previous ${afterLast}`;
  return `vs. ${formatPriorPeriodLabel(priorStart, priorEnd)}`;
};

export const formatChangePct = pct => {
  const abs = Math.abs(pct);
  if (abs >= 10_000) return ">9,999";
  if (abs >= 1_000) return `${Math.round(abs / 100) / 10}K`;
  return String(Math.round(abs));
};
